import { size } from 'lodash'

import regex from 'helpers/regex'
import validates from 'helpers/validates'

import cnpj from './cnpj'
import cpf from './cpf'

// mask=true formata progressivamente pelo tamanho digitado (uso em máscara de input).
// mask=false (padrão) formata pelo validador, mantendo o valor original se não for um CPF/CNPJ válido.
const identify = (document = '', mask = false) => {
  const clearedDocument = regex.onlyNumbersAndLetters(document)

  if (mask) {
    return size(clearedDocument) > 11 || validates.hasLetters(clearedDocument)
      ? cnpj(clearedDocument)
      : cpf(clearedDocument)
  }

  if (validates.cnpj.isValid(clearedDocument)) {
    return cnpj(clearedDocument)
  }

  if (validates.cpf.isValid(clearedDocument)) {
    return cpf(clearedDocument)
  }

  return document
}

export default { identify }
